(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-grid-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('p.rte');

    elements.forEach((el) => {
      const height = el.offsetHeight;

      // Trigger when block height is greater than 30px
      if (height > 30) {
        el.style.marginBottom = '0px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons-with-text"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sliders = document.querySelectorAll('carousel-slider > .slider-nav + div');
  
  sliders.forEach(slider => {
    const rotate = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const itemWidth = slider.querySelector('li')?.offsetWidth || slider.clientWidth;
      
      if (slider.scrollLeft >= maxScroll - 5) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }
    };

    let interval = setInterval(rotate, 6000);

    // Pause on interaction
    slider.addEventListener('mouseenter', () => clearInterval(interval));
    slider.addEventListener('mouseleave', () => interval = setInterval(rotate, 6000));
    slider.addEventListener('touchstart', () => clearInterval(interval), {passive: true});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
(function () {
  if (window.__pdDisclosureOpenInit) return;
  window.__pdDisclosureOpenInit = true;

  var DESKTOP_QUERY = '(min-width: 768px)';

  function openDetails(d) {
    if (d.open) return;
    var summary = d.querySelector(':scope > summary');
    if (summary) { summary.click(); } else { d.open = true; }
  }

  function openAll(selector) {
    document.querySelectorAll(selector).forEach(openDetails);
  }

  function initOpen() {
    openAll('details[data-open-always]:not([open])');

    if (window.matchMedia(DESKTOP_QUERY).matches) {
      openAll('details[data-open-desktop]:not([open])');
    } else {
      openAll('details[data-open-mobile]:not([open])');
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(initOpen);
})();

  } catch(e) { console.error(e); }
})();
})();
